<template>
  <b-card class="cardboardTop" title="Please tell us about the vehicles involved.">
    <b-alert variant="primary" show>
      <font-awesome-icon :icon="['fas', 'info-circle']"></font-awesome-icon>&nbsp;&nbsp;This vehicle will not be added until you click the
      <b>'Add Vehicle'</b> button below
    </b-alert>

       <transition name="fade" mode="out-in">
          <div id="errorCardTop" class="errorCard" v-if="error == true">
            <b-card class="errorCard">
              <h1>Validation Errors</h1>

              <ul>
                <li
                  v-for="(item, index) in errormessage"
                  v-bind:key="errormessage[index]"
                >{{ item }}</li>
              </ul>

              <span>
                <i>Please correct all the above validation errors before you can add this vehicle</i>
              </span>
            </b-card>
          </div>
        </transition>



    <b-form-group>
      <b-row>
        <b-col cols="2" v-on:click="vehicle.type == 'Car'">
          <div
            v-on:click="vehicle.type == 'Car'"
            v-bind:class="{ npfactive: vehicle.type == 'Car', npfnonActive :vehicle.type != 'Car' }"
          >
            <input
              v-on:click="vehicle.type == 'Car'"
              type="radio"
              id="carType"
              value="Car"
              v-model="vehicle.type"
            >
            <label for="carType">Car</label>
          </div>
        </b-col>
        <b-col cols="2" v-on:click="vehicle.type == 'Motorcycle'">
          <div
            v-on:click="vehicle.type == 'Motorcycle'"
            v-bind:class="{ npfactive: vehicle.type == 'Motorcycle', npfnonActive :vehicle.type != 'Motorcycle' }"
          >
            <input
              v-on:click="vehicle.type == 'Motorcycle'"
              type="radio"
              id="carTypeMC"
              value="Motorcycle"
              v-model="vehicle.type"
            >
            <label for="carTypeMC">Motorcycle</label>
          </div>
        </b-col>

        <b-col cols="2" v-on:click="vehicle.type == 'Bicycle'">
          <div
            v-on:click="vehicle.type == 'Bicycle'"
            v-bind:class="{ npfactive: vehicle.type == 'Bicycle', npfnonActive :vehicle.type != 'Bicycle' }"
          >
            <input type="radio" id="carTypebike" value="Bicycle" v-model="vehicle.type">
            <label v-on:click="vehicle.type == 'Bicycle'" for="carTypebike">Bicycle</label>
          </div>
        </b-col>
        <b-col cols="2" v-on:click="vehicle.type == 'Other'">
          <div
            v-on:click="vehicle.type == 'Other'"
            v-bind:class="{ npfactive: vehicle.type == 'Other', npfnonActive :vehicle.type != 'Other' }"
          >
            <input
              v-on:click="vehicle.type == 'Other'"
              type="radio"
              id="carTypeOther"
              value="Other"
              v-model="vehicle.type"
            >
            <label for="carTypeOther">Other</label>
          </div>
        </b-col>
      </b-row>
    </b-form-group>

    <b-form-group>
      <b-row>
        <b-col cols="12">
          <span class="npfQuestion">Make and model</span>
          <br>
          <span class="npfsubquestion">For example, Ford Fiesta</span>
          <b-form-input v-model="vehicle.makeandModel" placeholder="Ford Fiesta"></b-form-input>
        </b-col>
      </b-row>
    </b-form-group>

    <b-form-group>
      <b-row>
        <b-col cols="12">
          <span class="npfQuestion">Number plate or vehicle identification number</span>
          <br>
          <span class="npfsubquestion">We need this to identify the vehicle if we find it.</span>
          <b-form-input v-model="vehicle.VRM" placeholder="AB01 CDE"></b-form-input>
        </b-col>
      </b-row>
    </b-form-group>
    <b-form-group>
      <b-row>
        <b-col cols="12">
          <span class="npfQuestion">Any other information</span>
          <br>
          <span
            class="npfsubquestion"
          >Please include colour, where it was parked, and any other information that can help identify the vehicle.</span>
          <b-form-textarea
            v-model="vehicle.anyotherinfo"
            rows="5"
            max-rows="12"
            placeholder="Any Other infomation, please give as much as posible"
          ></b-form-textarea>
        </b-col>
      </b-row>
    </b-form-group>
    <b-form-group>
      <b-row>
        <b-col cols="12">
          <b-button v-on:click="$emit('cancelVehicle')" variant="danger">
            Cancel
            <font-awesome-icon :icon="['fas', 'times-circle']"></font-awesome-icon>
          </b-button>
          <b-button v-on:click="addchildVehicle()" variant="success">
            Add Vehicle
            <font-awesome-icon :icon="['fas', 'plus']"></font-awesome-icon>&nbsp;
            <font-awesome-icon :icon="['fas', 'car']"></font-awesome-icon>
          </b-button>
        </b-col>
      </b-row>
    </b-form-group>
  </b-card>
</template>

<script>
export default {
  data() {
    return {
      vehicle: {
        type: "",
        makeandModel: "",
        VRM: "",
        anyotherinfo: ""
      },
      error: false,
      errormessage: []
    };
  },
  methods: {
    addchildVehicle: function() {
      this.error = false;
      this.errormessage = [];

      if (this.vehicle.type == "") {
        this.error = true;
        this.errormessage.push("Please select a vehicle type");
      }
        if (this.vehicle.makeandModel == "" && this.vehicle.VRM == "" && this.vehicle.anyotherinfo == "") {
        this.error = true;
        this.errormessage.push("Please supply more information, either a make and model or a number plate or some other information");
      }
      if (!this.error) {
        this.$emit("addvehicle", this.vehicle);
      }
      else  
      {
          this.errorMessage();
      }
    },
     errorMessage() {
      var errormessage = this.errormessage;
      var htmlerror = "<div style='text-align: left;'><ul>";
      errormessage.forEach(function(item) {
        htmlerror += "<li>" + item + "</li>";
      });
      htmlerror += "</ul></div>";

      this.$swal("Validation Error(s)", htmlerror, "error");
    },
  }
};
</script>

<style>
</style>
